import { useAtomValue } from "jotai";

import { $isTemplate } from "../../internal/templates/is-template.atom";

/**
 * Hook that returns whether the given document is a template.
 */
export const useIsTemplate = (documentId: string | undefined) => {
	const isTemplate = useAtomValue($isTemplate(documentId));
	return { isTemplate };
};
